import { Icon, Tooltip } from 'antd';
import React from 'react';

const VisibilityOwnerView = ({ visible }) => {
  return (
    <Tooltip
      title={
        visible ? 'Собственник видит счётчик' : 'Собственник не видит счётчик'
      }
    >
      <Icon type={visible ? 'eye' : 'eye-invisible'} />
    </Tooltip>
  );
};

export default VisibilityOwnerView;
